import React from "react";
import * as UIConstants from "./UIConstants";

export const dateSort = (a, b) => {
  if (a === null) {
    return 1;
  }
  if (b === null) {
    return -1;
  }

  if (a.length === b.length && a.length === 10) {
    var dA =
      parseInt(a.substring(6, 10), 10) * 10000 +
      parseInt(a.substring(3, 5), 10) * 100 +
      parseInt(a.substring(0, 2), 10);
    var dB =
      parseInt(b.substring(6, 10), 10) * 10000 +
      parseInt(b.substring(3, 5), 10) * 100 +
      parseInt(b.substring(0, 2), 10);
    //console.log(dA,dB);
    return dA > dB ? 1 : -1;
  }
  return a.length > b.length ? 1 : -1;
};

export const computeSection = company => {
  var _sections = [];
  
  if (null != company) {
    for (var j = 0; j < company.sections.length; j++) {
      if (company.sections[j].enabled) {
        _sections.push(company.sections[j]);
      }
    }
  }
  return _sections;
};

export const numberFilterMethod = (filter, row) => {
  return row[filter.id].toString().startsWith(filter.value);
};

export const userIdFilterMethod = (filter, row) => {
  let searchStr = "";
  //console.log("userIdFilterMethod");
  //console.log(filter);
  //console.log(row[filter.id]);
  if (filter.value === "all") {
    return true;
  }    
  if (row[filter.id]) {
    searchStr = row[filter.id].userId;
  }
  return searchStr === filter.value;
};

export const selectFilterMethodInt = (filter, row) => {
  if (filter.value === "all") {
    return true;
  }
  return Number.parseInt(row[filter.id], 10) === Number.parseInt(filter.value, 10);
};

export const planningUserIdOptions = (planningUsers) => {
  let options = setFistOption();
  options.push(planningUsers.map(function(item, index) {
    return (
      <option key={`planning-user-id-${index}`} value={item == null ? "" : item.value}>
        {item == null ? "" : item.label}
      </option>
    );
  }));
  
  return options;
}

export const statusOptions = () => {
  let options = setFistOption();
  if (null !== UIConstants.REQUEST_STATUS) {

    options.push(UIConstants.REQUEST_STATUS.map(function(item, index) {
    return (
    <option key={`status-${index}`} value={item == null ? "" : item.name}>
      {item == null ? "" : item.label || item.name}
        </option>
      );
    }))
  }

  return options;
}
const setFistOption = () => {
  let options = []
  options.push(<option key="all" value="all">Afficher tout</option>);

  return options;
}

export const sectionOptions = (company) => {
  let options = setFistOption();
  if (null !== company) {
    options.push(computeSection(company).map(function(item, index) {
      return (
        <option key={ `section-${index}`} value={item == null ? "" : item.name}>
          {item == null ? "" : item.label || item.name}
        </option>
      );
    }));
  }

  return options;
}

export const companyOptions = (companies) => {
  let options = setFistOption();
  if (null !== companies) {
    options.push(companies.map(function(item, index) {
      return (
        <option key={ `company-${index}`} value={item == null ? "" : item.name}>
          {item == null ? "" : item.label || item.name}
        </option>
      );
    }));
  }

  return options;
}


// WEBPACK FOOTER //
// ./src/components/UI/helper.js